export const setState = (instance) => (newState) =>
    new Promise((resolve) => instance.setState(newState, resolve));
